import { BaseEntity } from "../../baseEntity";

export class StoredDataSelectorValue extends BaseEntity {

  protected readonly VALUE = "value";

  get value(): string { return this.getInternalValue<string>(this.VALUE); }
  setValue(value: string): this { return this.setInternalValue(this.VALUE, value); }
}